import { render } from "./SIdentify.vue?vue&type=template&id=4f38b334&scoped=true"
import script from "./SIdentify.vue?vue&type=script&lang=js"
export * from "./SIdentify.vue?vue&type=script&lang=js"

import "./SIdentify.vue?vue&type=style&index=0&id=4f38b334&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20221128.131745/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f38b334"]])

export default __exports__